module.exports = __webpack_public_path__ + "static/rocket-green-443438467e661024725654c2929e0ed0.svg";